import React from "react";
import { Drawer, Empty, Spin, Steps } from "antd";
import useUIStore from "../../store/ui";
import { getStatusesData } from "../../constants/main";
import useGetApi from "../../hooks/useGetApi";
import leaveApis from "../../api/methods/leaves";
import {
  IconCircleCheckFilled,
  IconProgress,
  IconX,
} from "@tabler/icons-react";
import appColors from "../../theme/common/colors";
import LeaveDetailsCard from "../common/Card/leaveDetails";

interface LeaveTrackerProps {
  onClose?: () => void;
}

interface OtherStatusData {
  parent_approved: "accepted" | "rejected" | "pending";
  principal_approved: "accepted" | "rejected" | "pending";
  lea_approved: "accepted" | "rejected" | "pending";
}

const LeaveTracker: React.FC<LeaveTrackerProps> = ({ onClose }) => {
  const leaveTrackerModal = useUIStore((state) => state.leaveTrackerModal);
  const leaveTrackerData = useUIStore((state) => state.leaveTrackerData);
  const closeLeaveTrackerModal = useUIStore(
    (state) => state.closeLeaveTrackerModal
  );
  const allStatuses = getStatusesData(leaveTrackerData?.duration ?? 0);
  const statuses = Object.keys(allStatuses);
  const {
    data: otherStatus,
    isLoading: isLoadingStatues,
    isError,
  } = useGetApi(leaveApis(leaveTrackerData?.id).getStatues);
  const currentStep = statuses.indexOf(leaveTrackerData?.status ?? "") || 0;
  console.log("leaveTrackerData", leaveTrackerData);

  const otherStatusData: OtherStatusData = otherStatus ? otherStatus[0] : null;

  const statusCard = (
    status: "accepted" | "rejected" | "pending",
    title: string,
    desc: string
  ) => {
    return (
      <div className="flex flex-row mt-2 gap-2 bg-slate-100 px-2 py-2 rounded-xl">
        {status === "accepted" ? (
          <IconCircleCheckFilled size={24} fill={appColors.green} />
        ) : status === "pending" ? (
          <IconProgress size={24} fill={appColors.yellow} />
        ) : status === "rejected" ? (
          <IconX size={24} fill={appColors.red} />
        ) : (
          <IconProgress size={24} fill={appColors.yellow} />
        )}

        <div>
          <p className="font-semibold text-[16px]">{title}</p>
          <p>{desc}</p>
        </div>
      </div>
    );
  };

  return (
    <Drawer
      width={600}
      title="Leave Tracker"
      open={leaveTrackerModal}
      onClose={() => {
        onClose?.();
        closeLeaveTrackerModal();
      }}
      footer={null}
    >
      {isLoadingStatues ? (
        <Spin />
      ) : isError ? (
        <Empty description="Failed to load data" />
      ) : (
        <div>
          <LeaveDetailsCard record={leaveTrackerData} />
          <div className="border p-2 border-slate-300 rounded-xl mb-4 mt-4 ">
            <p className="mb-2 ml-2">Approvals</p>
            {statusCard(
              otherStatusData?.principal_approved,
              "IS Granted",
              "Principal has reviewed the objectives and granted the request."
            )}
            {statusCard(
              otherStatusData?.parent_approved,
              "IS Accepted",
              "Parent has reviewed the objectives and accepted them."
            )}
          </div>
          <div className="border p-2 border-slate-300 rounded-xl mb-4 ">
            <p className="mb-2 ml-2">Progress</p>

            <Steps
              className="mx-2"
              progressDot
              current={currentStep}
              direction="vertical"
              items={statuses.map((key) => ({
                title: allStatuses[key].title,
                description: allStatuses[key].description,
              }))}
            />
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default LeaveTracker;
